import NewsSection from '@/sections/home/NewsSection'
import { WidgetFrame } from '../components/WidgetFrame'

const NewsWidgetPage = () => {
  return (
    <WidgetFrame>
      <NewsSection isWidget />
    </WidgetFrame>
  )
}

export default NewsWidgetPage
